import { types } from 'mobx-state-tree';
import { AsyncApi } from '@icecreamsocial/mst-models';
import { IcsV1, V2 } from '@icecreamsocial/api-resources';

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/**
 * @description Class representing a simple builder for creating API requests
 * @property {*} action an MST action from a Communicator-type MST
 * @property {*} [args] An object that specifies url keys and their values (not query params)
 * @property {*} [params] An object that specifies query param keys and their values
 * @property {*} [headers] An object that specifies header keys for a request and their values
 * @property {*} [options] An object that specifies AsyncApi options
 */
var RequestBuilder = /*#__PURE__*/function () {
  /**
   * Create a request builder
   * @param {*} CommunicatorAction
   */
  function RequestBuilder(CommunicatorAction) {
    _classCallCheck(this, RequestBuilder);
    this.action = CommunicatorAction;
    this.baseUrl = undefined;
    this.args = {};
    this.params = {};
    this.headers = {};
    this.options = {};
  }

  /**
   * A factory method for creating a request builder
   * @param {*} CommunicatorAction
   * @returns {RequestBuilder}
   */
  _createClass(RequestBuilder, [{
    key: "call",
    value: function call() {
      var CommunicatorAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.action;
      var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.baseUrl;
      var request = {
        args: this.args,
        params: this.params,
        headers: this.headers
      };
      if (baseUrl) {
        request.args.baseUrl = baseUrl;
      }
      return CommunicatorAction(request, this.options);
    }
  }, {
    key: "withArgs",
    value: function withArgs(args) {
      this.args = _objectSpread2(_objectSpread2({}, this.args), args);
      return this;
    }
  }, {
    key: "withAuthorization",
    value: function withAuthorization(key) {
      this.headers = _objectSpread2(_objectSpread2({}, this.headers), {}, {
        Authorization: "Bearer ".concat(key)
      });
      return this;
    }
  }, {
    key: "withBaseUrl",
    value: function withBaseUrl(url) {
      this.args.baseUrl = url;
      return this;
    }
  }, {
    key: "withHeaders",
    value: function withHeaders(headers) {
      this.headers = _objectSpread2(_objectSpread2({}, this.headers), headers);
      return this;
    }
  }, {
    key: "withOptions",
    value: function withOptions(options) {
      this.options = _objectSpread2(_objectSpread2({}, this.options), options);
      return this;
    }
  }, {
    key: "withParams",
    value: function withParams(params) {
      this.params = _objectSpread2(_objectSpread2({}, this.params), params);
      return this;
    }
  }], [{
    key: "request",
    value: function request(CommunicatorAction) {
      return new RequestBuilder(CommunicatorAction);
    }
  }]);
  return RequestBuilder;
}();

var CommunicationStore = types.model({}).named('Communicators').views(function (self) {
  return {
    createRequest: function createRequest(CommunicatorAction) {
      return RequestBuilder.request(CommunicatorAction);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Affiliates API
 */
var ICSAffiliatesResources = AsyncApi.named('ICSAffiliatesResources').actions(function (self) {
  return {
    getAffiliatesByLevel: function getAffiliatesByLevel(request, options) {
      return self.createAsyncApi(IcsV1.AffiliateV1.getAffiliatesByLevel)(request, options);
    },
    getAffiliateById: function getAffiliateById(request, options) {
      return self.createAsyncApi(IcsV1.AffiliateV1.getAffiliateById)(request, options);
    },
    createAffiliate: function createAffiliate(request, options) {
      return self.createAsyncApi(IcsV1.AffiliateV1.createAffiliate)(request, options);
    },
    updateAffiliate: function updateAffiliate(request, options) {
      return self.createAsyncApi(IcsV1.AffiliateV1.updateAffiliate)(request, options);
    },
    deleteAffiliate: function deleteAffiliate(request, options) {
      return self.createAsyncApi(IcsV1.AffiliateV1.deleteAffiliate)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS API-Keys API
 */
var ICSApiKeysResources = AsyncApi.named('ICSApiKeysResources').actions(function (self) {
  return {
    getApiKeys: function getApiKeys(request, options) {
      return self.createAsyncApi(IcsV1.ApiKeysV1.getApiKeys)(request, options);
    },
    createApiKey: function createApiKey(request, options) {
      return self.createAsyncApi(IcsV1.ApiKeysV1.createApiKey)(request, options);
    },
    deleteApiKey: function deleteApiKey(request, options) {
      return self.createAsyncApi(IcsV1.ApiKeysV1.deleteApiKey)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Auth API
 */
var ICSAuthResources = AsyncApi.named('ICSAuthResources').actions(function (self) {
  return {
    auth: function auth(request, options) {
      return self.createAsyncApi(IcsV1.AccountCreationV1.loginToAccount)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Campaigns API
 */
var ICSCampaignsResources = AsyncApi.named('ICSCampaignsResources').actions(function (self) {
  return {
    getCampaignsByLevel: function getCampaignsByLevel(request, options) {
      var maxAge = -1;
      return self.createAsyncApi(IcsV1.CampaignsV1.getCampaignsByLevel, maxAge)(request, options);
    },
    getCampaigns: function getCampaigns(request, options) {
      return self.createAsyncApi(IcsV1.CampaignsV1.getCampaigns)(request, options);
    },
    getCampaignById: function getCampaignById(request, options) {
      return self.createAsyncApi(IcsV1.CampaignsV1.getCampaignById)(request, options);
    },
    createCampaign: function createCampaign(request, options) {
      var maxAge = -1;
      return self.createAsyncApi(IcsV1.CampaignsV1.createCampaign, maxAge)(request, options);
    },
    updateCampaign: function updateCampaign(request, options) {
      var maxAge = -1;
      return self.createAsyncApi(IcsV1.CampaignsV1.updateCampaign, maxAge)(request, options);
    },
    deleteCampaign: function deleteCampaign(request, options) {
      return self.createAsyncApi(IcsV1.CampaignsV1.deleteCampaign)(request, options);
    },
    checkInfluencerProcessing: function checkInfluencerProcessing(request, options) {
      return self.createAsyncApi(IcsV1.CampaignsV1.checkInfluencerProcessing)(request, options);
    },
    getGatewayStatus: function getGatewayStatus(request, options) {
      return self.createAsyncApi(IcsV1.CampaignsV1.checkForValidGateway)(request, options);
    },
    getCampaignEcommerceInjectableScript: function getCampaignEcommerceInjectableScript(request, options) {
      return self.createAsyncApi(IcsV1.CampaignsV1.getCampaignEcommerceInjectableScript)(request, options);
    },
    getCampaignConversions: function getCampaignConversions(request, options) {
      return self.createAsyncApi(IcsV1.CampaignsV1.getCampaignConversions)(request, options);
    },
    exportCampaignConversions: function exportCampaignConversions(request, options) {
      return self.createAsyncApi(IcsV1.CampaignsV1.exportConversions)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Clients API
 */
var ICSClientsResources = AsyncApi.named('ICSClientsResources').actions(function (self) {
  return {
    getClientsByLevel: function getClientsByLevel(request, options) {
      return self.createAsyncApi(IcsV1.ClientV1.getClientByLevel)(request, options);
    },
    getClientById: function getClientById(request, options) {
      return self.createAsyncApi(IcsV1.ClientV1.getClientById)(request, options);
    },
    createClient: function createClient(request, options) {
      return self.createAsyncApi(IcsV1.ClientV1.createClient)(request, options);
    },
    updateClient: function updateClient(request, options) {
      return self.createAsyncApi(IcsV1.ClientV1.updateClient)(request, options);
    },
    deleteClient: function deleteClient(request, options) {
      return self.createAsyncApi(IcsV1.ClientV1.deleteClient)(request, options);
    },
    unsubscribe: function unsubscribe(request, options) {
      return self.createAsyncApi(IcsV1.ClientV1.unsubscribe)(request, options);
    },
    resubscribe: function resubscribe(request, options) {
      return self.createAsyncApi(IcsV1.ClientV1.resubscribe)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Companies API
 */
var ICSCompaniesResources = AsyncApi.named('ICSCompaniesResources').actions(function (self) {
  return {
    getCompany: function getCompany(request, options) {
      return self.createAsyncApi(IcsV1.CompanyV1.getCompany)(request, options);
    },
    updateCompany: function updateCompany(request, options) {
      var maxAge = -1;
      return self.createAsyncApi(IcsV1.CompanyV1.editCompany, maxAge)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS "Client" API
 */
var ICSCustomersResources = AsyncApi.named('ICSCustomersResources').actions(function (self) {
  return {
    createInfluencer2: function createInfluencer2(request, options) {
      return self.createAsyncApi(IcsV1.CustomerV1.createInfluencer2)(request, options);
    },
    createIntermidiaryConversion: function createIntermidiaryConversion(request, options) {
      return self.createAsyncApi(IcsV1.CustomerV1.createIntermidiaryConversion)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Affiliates API
 */
var ICSInfluencersResources = AsyncApi.named('ICSInfluencersResources').actions(function (self) {
  return {
    getInfluencers: function getInfluencers(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.getInfluencers)(request, options);
    },
    getInfluencerById: function getInfluencerById(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.getInfluencerById)(request, options);
    },
    exportInfluencers: function exportInfluencers(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.exportInfluencers)(request, options);
    },
    createInfluencer: function createInfluencer(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.createInfluencer)(request, options);
    },
    updateInfluencer: function updateInfluencer(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.updateInfluencer)(request, options);
    },
    deleteInfluencer: function deleteInfluencer(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.deleteInfluencer)(request, options);
    },
    getInvitesByInfluencerId: function getInvitesByInfluencerId(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.getInvitesByInfluencerId)(request, options);
    },
    getConversionByInfluencerId: function getConversionByInfluencerId(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.getConversionByInfluencerId)(request, options);
    },
    getInviteByInfluencerAndInviteId: function getInviteByInfluencerAndInviteId(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.getInviteByInfluencerAndInviteId)(request, options);
    },
    getConversionsByInfluencerAndInviteId: function getConversionsByInfluencerAndInviteId(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.getConversionsByInfluencerAndInviteId)(request, options);
    },
    getInfluencedConversionByInvitedInfluencerId: function getInfluencedConversionByInvitedInfluencerId(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.getInfluencedConversionByInvitedInfluencerId)(request, options);
    },
    deleteConversion: function deleteConversion(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.deleteConversion)(request, options);
    },
    postCliqReward: function postCliqReward(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.issueCliqRefundReward)(request, options);
    },
    postInfluencerProcessing: function postInfluencerProcessing(request, options) {
      return self.createAsyncApi(IcsV1.InfluencersV1.processInfluencer)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Invites API
 */
var ICSInvitesResources$1 = AsyncApi.named('ICSInvitesResources').actions(function (self) {
  return {
    getCampaignInvites: function getCampaignInvites(request, options) {
      return self.createAsyncApi(IcsV1.InvitesV1.getInvitesOfCampaign)(request, options);
    },
    updateInvite: function updateInvite(request, options) {
      return self.createAsyncApi(IcsV1.InvitesV1.updateInvite)(request, options);
    },
    exportInvites: function exportInvites(request, options) {
      return self.createAsyncApi(IcsV1.InvitesV1.exportInvites)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Stats API
 */
var ICSUsersResources$1 = AsyncApi.named('ICSUsersResources').actions(function (self) {
  return {
    getDailyStats: function getDailyStats(request, options) {
      return self.createAsyncApi(IcsV1.UsersV1.dailyStats)(request, options);
    },
    getStatisticsOverview: function getStatisticsOverview(request, options) {
      return self.createAsyncApi(IcsV1.UsersV1.statisticsOverview)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Invites API
 */
var ICSInvitesResources = AsyncApi.named('ICSInvitesResources').actions(function (self) {
  return {
    createProcessor: function createProcessor(request, options) {
      return self.createAsyncApi(IcsV1.ProcessorsV1.createProcessor)(request, options);
    },
    deleteProcessor: function deleteProcessor(request, options) {
      return self.createAsyncApi(IcsV1.ProcessorsV1.deleteProcessor)(request, options);
    },
    getProcessors: function getProcessors(request, options) {
      return self.createAsyncApi(IcsV1.ProcessorsV1.getProcessors)(request, options);
    },
    getProcessorById: function getProcessorById(request, options) {
      return self.createAsyncApi(IcsV1.ProcessorsV1.getProcessorById)(request, options);
    },
    getSquareProcessorLocations: function getSquareProcessorLocations(request, options) {
      return self.createAsyncApi(IcsV1.ProcessorsV1.getSquareProcessorLocations)(request, options);
    },
    revokeSquareAccessToken: function revokeSquareAccessToken(request, options) {
      return self.createAsyncApi(IcsV1.ProcessorsV1.revokeSquareAccessToken)(request, options);
    },
    updateProcessor: function updateProcessor(request, options) {
      return self.createAsyncApi(IcsV1.ProcessorsV1.updateProcessor)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Users API
 */
var ICSUsersResources = AsyncApi.named('ICSUsersResources').actions(function (self) {
  return {
    generateStateParam: function generateStateParam(request, options) {
      return self.createAsyncApi(IcsV1.UsersV1.generateStateParam)(request, options);
    },
    getUsersByLevel: function getUsersByLevel(request) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var maxAge = options.maxAge;
      return self.createAsyncApi(IcsV1.UsersV1.getUsersByLevel, maxAge)(request, options);
    },
    getUserById: function getUserById(request, options) {
      return self.createAsyncApi(IcsV1.UsersV1.getUserById)(request, options);
    },
    createUser: function createUser(request, options) {
      return self.createAsyncApi(IcsV1.UsersV1.createUser)(request, options);
    },
    updateUser: function updateUser(request, options) {
      var maxAge = options.maxAge;
      return self.createAsyncApi(IcsV1.UsersV1.updateUser, maxAge)(request, options);
    },
    deleteUser: function deleteUser(request, options) {
      return self.createAsyncApi(IcsV1.UsersV1.deleteUser)(request, options);
    }
  };
});

/**
 * @note Communicator Node
 * This model is an interface for external communication with ICS Affiliate API V2
 */
var AffiliatesResources = AsyncApi.named('AffiliatesResources').actions(function (self) {
  return {
    createAnAffiliate: function createAnAffiliate(request, options) {
      var maxAge = -1;
      return self.createAsyncApi(V2.Affiliates.createAnAffiliate, maxAge)(request, options);
    },
    updateAnAffiliate: function updateAnAffiliate(request, options) {
      var maxAge = -1;
      return self.createAsyncApi(V2.Affiliates.updateAnAffiliate, maxAge)(request, options);
    },
    deleteAnAffiliate: function deleteAnAffiliate(request, options) {
      var maxAge = -1;
      return self.createAsyncApi(V2.Affiliates.deleteAnAffiliate, maxAge)(request, options);
    },
    getAffiliateById: function getAffiliateById(request, options) {
      return self.createAsyncApi(V2.Affiliates.getAffiliateById)(request, options);
    },
    getNestedAffiliatesByAffiliateId: function getNestedAffiliatesByAffiliateId(request, options) {
      return self.createAsyncApi(V2.Affiliates.getNestedAffiliatesByAffiliateId)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Auth API V2
 */
var AuthResources = AsyncApi.named('AuthResources').actions(function (self) {
  return {
    auth: function auth(request, options) {
      return self.createAsyncApi(V2.Auth.getAuthorizationToken)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Campaigns API V2
 */
var CampaignsResources = AsyncApi.named('CampaignsResources').actions(function (self) {
  return {
    refundGatewayVerification: function refundGatewayVerification(request, options) {
      return self.createAsyncApi(V2.Campaigns.refundGatewayVerification)(request, options);
    },
    getIcsScriptByIntegrationPlatformMethod: function getIcsScriptByIntegrationPlatformMethod(request, options) {
      return self.createAsyncApi(V2.Campaigns.getIcsScriptByIntegrationPlatformMethod)(request, options);
    },
    // invites?
    getPaginatedInvites: function getPaginatedInvites(request, options) {
      return self.createAsyncApi(V2.Campaigns.getPaginatedInvites)(request, options);
    },
    exportInvites: function exportInvites(request, options) {
      return self.createAsyncApi(V2.Campaigns.exportInvites)(request, options);
    },
    getInvite: function getInvite(request, options) {
      return self.createAsyncApi(V2.Campaigns.getInvite)(request, options);
    },
    updateInvite: function updateInvite(request, options) {
      return self.createAsyncApi(V2.Campaigns.updateInvite)(request, options);
    },
    getInvitesByInfluencerId: function getInvitesByInfluencerId(request, options) {
      return self.createAsyncApi(V2.Campaigns.getInvitesByInfluencerId)(request, options);
    },
    // conversions?
    createManualConversion: function createManualConversion(request, options) {
      return self.createAsyncApi(V2.Campaigns.createManualConversion)(request, options);
    },
    getConversionsOfAnInvite: function getConversionsOfAnInvite(request, options) {
      return self.createAsyncApi(V2.Campaigns.getConversionsOfAnInvite)(request, options);
    },
    getInfluencedConversionsByInvitedInfluencerId: function getInfluencedConversionsByInvitedInfluencerId(request, options) {
      return self.createAsyncApi(V2.Campaigns.getInfluencedConversionsByInvitedInfluencerId)(request, options);
    },
    getConversionsByInfluencerId: function getConversionsByInfluencerId(request, options) {
      return self.createAsyncApi(V2.Campaigns.getConversionsByInfluencerId)(request, options);
    },
    cancelConversion: function cancelConversion(request, options) {
      return self.createAsyncApi(V2.Campaigns.cancelConversion)(request, options);
    },
    deleteAConversion: function deleteAConversion(request, options) {
      return self.createAsyncApi(V2.Campaigns.deleteAConversion)(request, options);
    },
    getConversionsOfACampaign: function getConversionsOfACampaign(request, options) {
      return self.createAsyncApi(V2.Campaigns.getConversionsOfACampaign)(request, options);
    },
    exportConversions: function exportConversions(request, options) {
      return self.createAsyncApi(V2.Campaigns.exportConversions)(request, options);
    },
    getPaginatedConversions: function getPaginatedConversions(request, options) {
      return self.createAsyncApi(V2.Campaigns.getPaginatedConversions)(request, options);
    },
    // campaign influencers ?
    getInfluencerById: function getInfluencerById(request, options) {
      return self.createAsyncApi(V2.Campaigns.getInfluencerById)(request, options);
    },
    anonymizeInfluencer: function anonymizeInfluencer(request, options) {
      return self.createAsyncApi(V2.Campaigns.anonymizeInfluencer)(request, options);
    },
    updateInfluencer: function updateInfluencer(request, options) {
      return self.createAsyncApi(V2.Campaigns.updateInfluencer)(request, options);
    },
    deleteInfluencer: function deleteInfluencer(request, options) {
      return self.createAsyncApi(V2.Campaigns.deleteInfluencer)(request, options);
    },
    processInfluencer: function processInfluencer(request, options) {
      return self.createAsyncApi(V2.Campaigns.processInfluencer)(request, options);
    },
    createInfluencer: function createInfluencer(request, options) {
      return self.createAsyncApi(V2.Campaigns.createInfluencer)(request, options);
    },
    getInfluencers: function getInfluencers(request, options) {
      return self.createAsyncApi(V2.Campaigns.getInfluencers)(request, options);
    },
    exportInfluencers: function exportInfluencers(request, options) {
      return self.createAsyncApi(V2.Campaigns.exportInfluencers)(request, options);
    },
    showInfluencerRewardInformation: function showInfluencerRewardInformation(request, options) {
      return self.createAsyncApi(V2.Campaigns.showInfluencerRewardInformation)(request, options);
    },
    // campaign
    getCampaignById: function getCampaignById(request, options) {
      return self.createAsyncApi(V2.Campaigns.getCampaignById)(request, options);
    },
    updateCampaign: function updateCampaign(request, options) {
      var maxAge = -1;
      return self.createAsyncApi(V2.Campaigns.updateCampaign, maxAge)(request, options);
    },
    deleteCampaign: function deleteCampaign(request, options) {
      return self.createAsyncApi(V2.Campaigns.deleteCampaign)(request, options);
    },
    createCampaign: function createCampaign(request, options) {
      var maxAge = -1;
      return self.createAsyncApi(V2.Campaigns.createCampaign, maxAge)(request, options);
    },
    getCampaignByFilter: function getCampaignByFilter(request, options) {
      return self.createAsyncApi(V2.Campaigns.getCampaignByFilter)(request, options);
    },
    unsubscribe: function unsubscribe(request, options) {
      return self.createAsyncApi(V2.Campaigns.unsubscribe)(request, options);
    },
    resubscribe: function resubscribe(request, options) {
      return self.createAsyncApi(V2.Campaigns.resubscribe)(request, options);
    },
    getDiscounts: function getDiscounts(request, options) {
      return self.createAsyncApi(V2.Campaigns.getCampaignDiscounts)(request, options);
    },
    updateDiscounts: function updateDiscounts(request, options) {
      return self.createAsyncApi(V2.Campaigns.updateCampaignDiscounts)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Client API V2
 */
var ClientResources = AsyncApi.named('ClientResources').actions(function (self) {
  return {
    createGenericInvite: function createGenericInvite(request, options) {
      return self.createAsyncApi(V2.Client.createGenericInvite)(request, options);
    },
    createInfluencer: function createInfluencer(request, options) {
      return self.createAsyncApi(V2.Client.createInfluencer)(request, options);
    },
    getCampaignInformation: function getCampaignInformation(request, options) {
      return self.createAsyncApi(V2.Client.getCampaignInformation)(request, options);
    },
    sendEmailToInfluencer: function sendEmailToInfluencer(request, options) {
      return self.createAsyncApi(V2.Client.sendEmailToInfluencer)(request, options);
    },
    createFacebookInvite: function createFacebookInvite(request, options) {
      return self.createAsyncApi(V2.Client.createFacebookInvite)(request, options);
    },
    createEmailInvite: function createEmailInvite(request, options) {
      return self.createAsyncApi(V2.Client.createEmailInvite)(request, options);
    },
    createInfluencerFromClientIntermediaryConversion: function createInfluencerFromClientIntermediaryConversion(request, options) {
      return self.createAsyncApi(V2.Client.createInfluencerFromClientIntermediaryConversion)(request, options);
    },
    createInviteHashAndCookies: function createInviteHashAndCookies(request, options) {
      return self.createAsyncApi(V2.Client.createInviteHashAndCookies)(request, options);
    },
    unsubscribe: function unsubscribe(request, options) {
      return self.createAsyncApi(V2.Client.unsubscribe)(request, options);
    },
    resubscribe: function resubscribe(request, options) {
      return self.createAsyncApi(V2.Client.resubscribe)(request, options);
    },
    getCampaignDiscounts: function getCampaignDiscounts(request, options) {
      return self.createAsyncApi(V2.Client.getCampaignDiscounts)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Clients API V2
 */
var ClientsResources = AsyncApi.named('ClientsResources').actions(function (self) {
  return {
    getClientById: function getClientById(request, options) {
      return self.createAsyncApi(V2.Clients.getClientById)(request, options);
    },
    deleteClient: function deleteClient(request, options) {
      return self.createAsyncApi(V2.Clients.deleteClient)(request, options);
    },
    updateClient: function updateClient(request, options) {
      return self.createAsyncApi(V2.Clients.updateClient)(request, options);
    },
    createAClient: function createAClient(request, options) {
      return self.createAsyncApi(V2.Clients.createAClient)(request, options);
    },
    createClientUseCase: function createClientUseCase(request, options) {
      return self.createAsyncApi(V2.Clients.createClientUseCase)(request, options);
    },
    getClientUseCaseStatus: function getClientUseCaseStatus(request, options) {
      return self.createAsyncApi(V2.Clients.getClientUseCaseStatus)(request, options);
    },
    getNestedClients: function getNestedClients(request, options) {
      return self.createAsyncApi(V2.Clients.getNestedClients)(request, options);
    },
    regeneratePublicKey: function regeneratePublicKey(request, options) {
      return self.createAsyncApi(V2.Clients.regeneratePublicKey)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Public API V2
 */
var PublicResources = AsyncApi.named('PublicResources').actions(function (self) {
  return {
    createInfluencer: function createInfluencer(request, options) {
      return self.createAsyncApi(V2.Public.createInfluencer)(request, options);
    },
    getCampaign: function getCampaign(request, options) {
      return self.createAsyncApi(V2.Public.getCampaign)(request, options);
    },
    emailInfluencer: function emailInfluencer(request, options) {
      return self.createAsyncApi(V2.Public.emailInfluencer)(request, options);
    },
    trackConversion: function trackConversion(request, options) {
      return self.createAsyncApi(V2.Public.trackConversion)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Users API V2
 */
var UsersResources = AsyncApi.named('UsersResources').actions(function (self) {
  return {
    getASingleUserInformationByUserId: function getASingleUserInformationByUserId(request, options) {
      return self.createAsyncApi(V2.Users.getASingleUserInformationByUserId)(request, options);
    },
    updatesAUser: function updatesAUser(request, options) {
      return self.createAsyncApi(V2.Users.updatesAUser)(request, options);
    },
    getAdminUsers: function getAdminUsers(request, options) {
      return self.createAsyncApi(V2.Users.getAdminUsers)(request, options);
    },
    createsAdminUser: function createsAdminUser(request, options) {
      return self.createAsyncApi(V2.Users.createsAdminUser)(request, options);
    },
    getNestedAdminUsersByAffiliateId: function getNestedAdminUsersByAffiliateId(request, options) {
      return self.createAsyncApi(V2.Users.getNestedAdminUsersByAffiliateId)(request, options);
    },
    getCampaignOverviewStatistics: function getCampaignOverviewStatistics(request, options) {
      return self.createAsyncApi(V2.Users.getCampaignOverviewStatistics)(request, options);
    },
    getDailyCampaignStatistics: function getDailyCampaignStatistics(request, options) {
      return self.createAsyncApi(V2.Users.getDailyCampaignStatistics)(request, options);
    },
    generateUserStateParam: function generateUserStateParam(request, options) {
      return self.createAsyncApi(V2.Users.generateUserStateParam)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Webhooks API V2
 */
var WebhooksResources = AsyncApi.named('WebhooksResources').actions(function (self) {
  return {
    registerCampaignToWebhook: function registerCampaignToWebhook(request, options) {
      return self.createAsyncApi(V2.Webhooks.registerCampaignToWebhook)(request, options);
    },
    getRegisteredCampaignWebhooks: function getRegisteredCampaignWebhooks(request, options) {
      return self.createAsyncApi(V2.Webhooks.getRegisteredCampaignWebhooks)(request, options);
    },
    removeWebhookSubscription: function removeWebhookSubscription(request, options) {
      return self.createAsyncApi(V2.Webhooks.removeWebhookSubscription)(request, options);
    },
    getWebhookEvents: function getWebhookEvents(request, options) {
      return self.createAsyncApi(V2.Webhooks.getWebhookEvents)(request, options);
    }
  };
});

/**
 * @note Communicator Node
 * This model is an interface for external communication with ICS Company API V2
 */
var CompanyResources = AsyncApi.named('CompanyResources').actions(function (self) {
  return {
    getCompanyInformation: function getCompanyInformation(request, options) {
      return self.createAsyncApi(V2.Company.getCompanyInformation)(request, options);
    },
    updateCompanyInformation: function updateCompanyInformation(request, options) {
      return self.createAsyncApi(V2.Company.updateCompanyInformation)(request, options);
    },
    bulkUpdateCompanyCampaigns: function bulkUpdateCompanyCampaigns(request, options) {
      return self.createAsyncApi(V2.Company.bulkUpdateCompanyCampaigns)(request, options);
    }
  };
});

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Processors API V2
 */
var ProcessorsResources = AsyncApi.named('ProcessorsResources').actions(function (self) {
  return {
    getProcessorInformationById: function getProcessorInformationById(request, options) {
      return self.createAsyncApi(V2.Processors.getProcessorInformationById)(request, options);
    },
    getAllAccessibleProcessors: function getAllAccessibleProcessors(request, options) {
      return self.createAsyncApi(V2.Processors.getAllAccessibleProcessors)(request, options);
    },
    getSquareLocationsOfTheSquareProcessor: function getSquareLocationsOfTheSquareProcessor(request, options) {
      return self.createAsyncApi(V2.Processors.getSquareLocationsOfTheSquareProcessor)(request, options);
    },
    createProcessor: function createProcessor(request, options) {
      return self.createAsyncApi(V2.Processors.createProcessor)(request, options);
    },
    updateProcessor: function updateProcessor(request, options) {
      return self.createAsyncApi(V2.Processors.updateProcessor)(request, options);
    },
    deleteProcessor: function deleteProcessor(request, options) {
      return self.createAsyncApi(V2.Processors.deleteProcessor)(request, options);
    },
    updateProcessorSquareToken: function updateProcessorSquareToken(request, options) {
      return self.createAsyncApi(V2.Processors.updateProcessorSquareToken)(request, options);
    },
    revokeStripeToken: function revokeStripeToken(request, options) {
      return self.createAsyncApi(V2.Processors.revokeStripeToken)(request, options);
    }
  };
});

// @ts-nocheck

/**
 * @note Communicator Node
 * This model is an interface for external communication with the ICS Rewards API V2
 */
var RewardsResources = AsyncApi.named('RewardsResources').actions(function (self) {
  return {
    getPaginatedRewards: function getPaginatedRewards(request, options) {
      return self.createAsyncApi(V2.Rewards.getPaginatedRewards)(request, options);
    },
    getRewardsExport: function getRewardsExport(request, options) {
      return self.createAsyncApi(V2.Rewards.getRewardsExport)(request, options);
    }
  };
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ICSAffiliatesAPIV2: AffiliatesResources,
  ICSAuthAPIV2: AuthResources,
  ICSCampaignsAPIV2: CampaignsResources,
  ICSClientAPIV2: ClientResources,
  ICSClientsAPIV2: ClientsResources,
  ICSPublicAPIV2: PublicResources,
  ICSUsersAPIV2: UsersResources,
  ICSWebhooksAPIV2: WebhooksResources,
  ICSCompanyAPIV2: CompanyResources,
  ICSProcessorsAPIV2: ProcessorsResources,
  ICSRewardsAPIV2: RewardsResources
});

export { CommunicationStore as BaseCommunicator, ICSAffiliatesResources as ICSAffiliatesAPI, ICSApiKeysResources as ICSApiKeysAPI, ICSAuthResources as ICSAuthAPI, ICSCampaignsResources as ICSCampaignsAPI, ICSClientsResources as ICSClientsAPI, ICSCompaniesResources as ICSCompaniesAPI, ICSCustomersResources as ICSCustomersAPI, ICSInfluencersResources as ICSInfluencersAPI, ICSInvitesResources$1 as ICSInvitesAPI, ICSInvitesResources as ICSProcessorsAPI, ICSUsersResources$1 as ICSStatsAPI, ICSUsersResources as ICSUsersAPI, index as ICSV2 };
